import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Map, List } from 'immutable';

import * as configActions from 'modules/config';
import * as adminActions from 'modules/admin';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';

import { ConfigInitial } from 'components';

class CtConfigInitial extends Component {
  constructor(props) {
    super(props);

    this.state = { isModal: false, onProgress: false };
  }

  onToggleModal = type => {
    this.setState({ isModal: type });
  };

  onInitialConfig = async () => {
    this.setState({ onProgress: true });

    try {
      const { isAuth, category, AdminActions, ConfigActions } = this.props;
      if (isAuth === 2) {
        if (category === 'basic') {
          await AdminActions.SystemConfigInitBasic();
          await AdminActions.getSystemConfigBasic();
        } else if (category === 'smtp') {
          await AdminActions.SystemConfigInitSmtp();
          await AdminActions.getSystemConfigSmtp();
        }
      } else {
        await ConfigActions.ServiceConfigInitSmtp();
        await ConfigActions.getServiceConfig({ category: 'smtp' });
      }
    } catch (e) {
      console.log(e);
    }
    this.setState({ onProgress: false, isModal: false });
  };

  render() {
    const { onInitialConfig, onToggleModal } = this;
    const { isModal, onProgress } = this.state;

    return (
      <ConfigInitial
        isModal={isModal}
        onProgress={onProgress}
        onInitialConfig={onInitialConfig}
        onToggleModal={onToggleModal}
      />
    );
  }
}

CtConfigInitial.propTypes = {};

const mapStateToProps = state => {
  return {
    isAuth: state.user.get('isAuth')
  };
};

const mapDispatchToProps = dispatch => ({
  ConfigActions: bindActionCreators(configActions, dispatch),
  AdminActions: bindActionCreators(adminActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CtConfigInitial);



// WEBPACK FOOTER //
// ./src/script/containers/config/CtConfigInitial.js